import { useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { errorHandleMiddleware } from '@entities/attachment/lib';
import { TAttachmentOnClient } from '@entities/attachment/model/types';
import { generateId } from '@shared/helpers';
import { newSumFormFormatter } from '@shared/helpers/sumFormFormatter';

export const useGenerateMeasurementModal = () => {
    const { t } = useTranslation();

    const errorsText = {
        FORMAT: 'Файл должен быть в одном из форматов: JPEG, PNG, GIF, WebP',
        SIZE: t('Tasks.ModalFileUploader.useUploadFile.SizeError.text'),
        COUNT: t('Tasks.ModalFileUploader.useUploadFile.CountError.text'),
        ONE_FILE_COUNT: t('Tasks.ModalFileUploader.useUploadFile.OneFileCountError.text'),
    };

    const [error, setError] = useState<null | string>(null);
    const [form, setForm] = useState({
        attachment: [],
        height: '',
        // select: 'notApply',
    });

    // const onSelect = (value: string) => {
    //     setForm({ ...form, select: value });
    // };

    const onInput = (name: string, value: string) => {
        const height = newSumFormFormatter(value);
        setForm((prev) => ({
            ...prev,
            height,
        }));
    };

    const fileInputRef = useRef<HTMLInputElement>(null);
    const onClickInputRef = () => {
        fileInputRef.current?.click();
    };

    // const onInputChange = (name: string, value: string) => {
    //     setForm((prevState) => ({ ...prevState, [name]: value }));
    // };

    const onAddFiles = async (files: File[]) => {
        setError(null);
        const newAttachment: TAttachmentOnClient[] = files.map((file) => ({
            id: generateId(true) as number,
            file,
            isLoading: true,
        }));

        setForm((prevState) => ({ ...prevState, attachment: newAttachment }));
    };

    const onErrorCb = (textError: string) => {
        setForm((prevState) => ({ ...prevState, attachment: [] }));
        setError(textError);
    };

    const uploadFilesHandler = errorHandleMiddleware({
        onAddFiles,
        onErrorCb,
        errorsText,
        t,
        maxAttachmentSizeInMb: 1000,
        maxOverallSizeInMb: 10000,
        multiple: false,
        validateExtensions: ['png', 'jpeg', 'gif', 'jpg', 'webp'],
    });

    return { t, form, uploadFilesHandler, fileInputRef, onClickInputRef, error, onInput };
};
